import { GoogleGenAI } from "@google/genai";

export const ChatService = {
  /**
   * Platzhalter für zukünftige RAG-Anbindung.
   * Hier kann später eine Vektordatenbank (z.B. Pinecone) abgefragt werden.
   */
  getCompanyContext: async (query: string): Promise<string> => {
    // Spätere Implementierung: 
    // const results = await vectorDb.search(query);
    // return results.join("\n");
    return "";
  },

  sendMessage: async (
    userText: string,
    context: string = 'general',
    onToken: (token: string) => void
  ): Promise<string> => {

    let apiKey = '';
    try {
      // Zugriff auf process.env gemäß Vorgabe
      apiKey = typeof process !== 'undefined' && process.env ? process.env.API_KEY || '' : '';
    } catch (e) {
      console.warn("API Key access error", e);
    }

    if (!apiKey) {
      const msg = "System-Hinweis: API_KEY fehlt in der Umgebungskonfiguration.";
      onToken(msg);
      return msg;
    }

    const ai = new GoogleGenAI({ apiKey });

    const baseInstructions: Record<string, string> = {
      'general': "Du bist der KI-Berater von CleverDigital aus Wien. Wir sind spezialisiert auf intelligente Digitalisierung und KI-Lösungen für KMU in der DACH-Region. Antworte präzise, freundlich und praxisorientiert.",
      'law': "Du bist ein Legal-Tech Experte von CleverDigital. Fokus: Kanzlei-Automatisierung und DSGVO-Konformität.",
      'medicine': "Du bist ein Medical-IT Consultant von CleverDigital. Fokus: Sichere KI für Mediziner und Praxen.",
      'finance': "Du bist ein Fintech-Architekt von CleverDigital. Fokus: Compliance und Automatisierung.",
      'estate': "Du bist ein Prop-Tech Experte von CleverDigital. Fokus: Immobilien-Digitalisierung.",
      'craft': "Du bist ein Digitalisierungs-Experte von CleverDigital. Fokus: Handwerk & Produktion."
    };

    try {
      const companyContext = await ChatService.getCompanyContext(userText);
      let systemInstruction = baseInstructions[context] || baseInstructions.general;

      if (companyContext) {
        systemInstruction += `\n\nZusätzlicher Kontext aus Firmendaten:\n${companyContext}`;
      }

      const responseStream = await ai.models.generateContentStream({
        model: 'gemini-3-flash-preview',
        contents: [{ role: 'user', parts: [{ text: userText }] }],
        config: {
          systemInstruction: systemInstruction,
          temperature: 0.7,
        },
      });

      let fullResponse = "";
      for await (const chunk of responseStream) {
        const chunkText = chunk.text;
        if (chunkText) {
          fullResponse += chunkText;
          onToken(chunkText);
        }
      }
      return fullResponse;
    } catch (error) {
      console.error("AI Service Error:", error);
      const errorMsg = "Entschuldigung, ich habe gerade Verbindungsschwierigkeiten. Bitte versuchen Sie es gleich noch einmal.";
      onToken(errorMsg);
      return errorMsg;
    }
  }
};
